<template>
  <div id="map">
    <svg class="canvas" :viewBox="`0, 0, ${width}, ${height}`">
      <g class="pathGroup"></g>
      <text id="tooltip" x="50" y="50">{{ displayedCountry }}</text>
    </svg>
  </div>
</template>

<script>
import json from "@/views/dashboard/assets/world.json";
import { geoPath, geoEqualEarth, geoMercator } from "d3-geo";
import * as selection from "d3-selection";
import * as zoom from "d3-zoom";
import { feature } from "topojson-client";
import map_data from '../api/map_data'

export default {
    name: "Map",
    data() {
        return {
            myJson: feature(json, json.objects["ne_50m_admin_0_countries_lakes"]),
            displayedCountry: "",
            width: 990,
            height: 490
        };
    },
    computed: {
        projection() {
            return geoEqualEarth().fitSize([this.width, this.height], this.myJson);
        },
        path() {
            return geoPath().projection(this.projection);
        },
        g() {
            return selection.select(".pathGroup");
        },
        svg() {
            return selection.select(".canvas");
        },
        zoom() {
            return zoom
                .zoom()
                .scaleExtent([1, 8])
                .on("zoom", this.zoomed);
        }
    },
    methods: {
        zoomed() {
            const { transform } = selection.event;
            this.g.attr("transform", transform);
            this.g.attr("stroke-width", 1 / transform.k);
        },
        clicked(d) {
            const [[x0, y0], [x1, y1]] = this.path.bounds(d);
            selection.event.stopPropagation();
            this.svg
                .transition()
                .duration(750)
                .call(
                    this.zoom.transform,
                    zoom.zoomIdentity
                        .translate(this.width / 2, this.height / 2)
                        .scale(
                            Math.min(
                                8,
                                0.9 / Math.max((x1 - x0) / this.width, (y1 - y0) / this.height)
                            )
                        )
                        .translate(-(x0 + x1) / 2, -(y0 + y1) / 2),
                    selection.mouse(this.svg.node())
                );
        },
        reset() {
            this.svg
                .transition()
                .duration(750)
                .call(
                    this.zoom.transform,
                    zoom.zoomIdentity,
                    zoom
                        .zoomTransform(this.svg.node())
                        .invert([this.width / 2, this.height / 2])
                );
        },
        mouseentered(d, i, nodes) {
            this.displayedCountry = `${d.properties.NAME}${d.amount?': '+d.amount:''}`;
            selection
                .select(nodes[i])
                .classed("active", true);
                // .raise();
        },
        mouseleft(d, i, nodes) {
            this.displayedCountry = "";
            selection.select(nodes[i]).classed("active", false);
        },
        displayPoints(places){
            let projection = geoMercator();

            this.g.selectAll(".pin")
                .data(places)
                .enter().append("circle", ".pin")
                .attr("r", 10)
                .attr("fill", "#ADC509")
                .attr("stroke", "#56672E")
                .attr("stroke-width", "2px")
                .on("mouseenter", this.mouseentered)
                .on("mouseleave", this.mouseleft)
                .attr("transform", function(d) {
                    return "translate(" + projection([
                        d.location.longitude,
                        d.location.latitude
                    ]) + ")";
                })
                .append("text")
                .text(function(d) {
                    return "TEXTO"
                })
                .attr("transform", function(d) {
                    return "translate(" + projection([
                        d.location.longitude,
                        d.location.latitude
                    ]) + ")";
                });

            this.g.selectAll(".pin")
                .data(places)
                
        }
    },
    mounted() {
        this.g
            .selectAll(".country")
            .data(this.myJson.features)
            .join("path")
            .attr("class", "country")
            .attr("d", this.path)
            .on("mouseenter", this.mouseentered)
            .on("mouseleave", this.mouseleft)
            .on("click", this.clicked);

        this.svg.on("click", this.reset).call(this.zoom);

        this.displayPoints(map_data)
    }
};
</script>

<style lang="scss">
    .country {
        fill: #1B2635;
        stroke: #4D5664;
    }

    #tooltip {
        font-size: 1.5rem;
        stroke: #ffffff;
        fill: #ffffff;
    }
    .active {
        stroke: #4782DA;
    }
</style>
